// Breadcrumb des Explorers im Refined-Design.
//
// Ersetzt den Fluent-`Breadcrumb`, der Fremd-Optik (eigene Tokens, eigene
// Schriftgrößen) in den kvp-rd-Scope zöge. Zusätzlich links der
// „eine Ebene hoch"-Knopf — auf schmalen Panels ist der Ordnerbaum
// ausgeblendet und das hier die einzige Möglichkeit zurückzunavigieren.

import * as React from "react";
import { ArrowUp16Regular, Home16Regular } from "@fluentui/react-icons";
import { folderSegments, parentPath } from "./explorerModel";
import { useDropZiel, type ExplorerDropZiel } from "./FolderTree";

export const ExplorerBreadcrumb: React.FC<{
  rootLabel: string;
  path: string;
  onNavigate: (path: string) => void;
  /** Lesbarer Name eines Pfades, falls das Segment selbst keiner ist; `""` blendet es aus. */
  segmentLabel?: (path: string) => string | undefined;
  /** Brotkrumen als Ziel beim Verschieben („eine Ebene höher ablegen"). */
  dropZiel?: ExplorerDropZiel;
}> = ({ rootLabel, path, onNavigate, segmentLabel, dropZiel }) => {
  const segments = folderSegments(path);
  const drop = useDropZiel(dropZiel);
  const atRoot = segments.length === 0;

  return (
    <div className="docx-crumb">
      <button
        type="button"
        className="docx-up"
        onClick={() => onNavigate(parentPath(path))}
        disabled={atRoot}
        title="Eine Ebene nach oben"
        aria-label="Eine Ebene nach oben"
      >
        <ArrowUp16Regular />
      </button>
      <nav aria-label="Ordnerpfad" style={{ display: "flex", alignItems: "center", minWidth: 0 }}>
        <button
          type="button"
          className={"docx-crumb-btn" + (drop.ueber === "" ? " drop" : "")}
          aria-current={atRoot ? "page" : undefined}
          onClick={() => !atRoot && onNavigate("")}
          {...drop.props("")}
        >
          <Home16Regular />
          {rootLabel}
        </button>
        {segments.map((seg, i) => {
          const target = segments.slice(0, i + 1).join("/") + "/";
          const isLast = i === segments.length - 1;
          const label = segmentLabel?.(target) ?? seg;
          // Reine Sammelknoten (keine echten Ordner) erscheinen nicht.
          if (label === "") return null;
          return (
            <React.Fragment key={target}>
              <span className="docx-crumb-sep" aria-hidden>
                ›
              </span>
              <button
                type="button"
                className={"docx-crumb-btn" + (drop.ueber === target ? " drop" : "")}
                aria-current={isLast ? "page" : undefined}
                onClick={() => !isLast && onNavigate(target)}
                title={label}
                {...drop.props(target)}
              >
                {label}
              </button>
            </React.Fragment>
          );
        })}
      </nav>
    </div>
  );
};
